<template>
  <a v-if="!deleted" href="#0!" @click.prevent="showFileDetails" class="box ck-file">
      <div class="ck-file-name">
          <div class="fa fa-file"> &ndash; {{ fileName }}</div>
      </div>
      <transition name="slide-fade">
        <div class="details" v-show="fileDetails">
            <div>Hochgeladen am: {{ fileCreated }}</div>
            <div class="has-margin-bottom-0-5">Größe: {{ fileSize/1000 }} kb</div>
            <button @click="downloadFile(fileId, fileName)" class="button is-small is-primary" download><i class="fa fa-download"></i> Download</button>
            <button @click="deleteFile" class="button is-small is-danger"><i class="fa fa-trash"></i> Löschen</button>
        </div>
      </transition>
  </a>
</template>

<script>
export default {
    props: ['fileName', 'fileType', 'fileId', 'fileSize', 'fileCreated'],
    data: function() {
        return {
            fileDetails: false,
            deleted: false
        }
    },
    methods: {
        showFileDetails() {
            this.fileDetails = !this.fileDetails
        },
        deleteFile() {
            axios.get(`/files/delete/${this.fileId}`).then(res => {
                if(res.status < 400) {
                    this.deleted = true;
                }
            }).catch(err => console.log(err));
        },
        downloadFile(fileId, fileName) {
            axios.get(`/files/${fileId}`, {
                responseType: 'blob'
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        }
    }
}
</script>

<style scoped>
    .ck-file-name {
        display: flex;
        justify-content: space-between;
    }

    .details {
        padding: 0.25rem 0;
    }

    /* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/ckFileLink.vue